'use client';

import { useGlobalMGLProps } from '@/Util/GlobalMGLPropsContext';
import styles from './BreadCrumb.module.scss';
import Link from 'next/link';
import { faHome, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Fragment } from 'react';
import YsnConfigModel from '@/Config/YsnConfigModel';
import { useConfig } from '@ibe/components';
import { getLinkUrl } from '../linkList/Link';

const BreadCrumb = () => {
  const mgnlCtx = useGlobalMGLProps();
  const config = useConfig() as YsnConfigModel;

  const { breadCrumb: breadCrumbNodes = [], rootNodePath } = mgnlCtx || {};
  if (!breadCrumbNodes.length) return <></>;
  return (
    <div className={`iso__breadCrumb ${styles.iso__breadCrumb}`}>
      {breadCrumbNodes?.map(node => {
        if (node.path === rootNodePath) {
          return (
            <Link key={node.path} href={rootNodePath}>
              <span className="mr-2">
                <FontAwesomeIcon icon={faHome} />
              </span>
            </Link>
          );
        }
        return (
          <Fragment key={node.path}>
            <FontAwesomeIcon icon={faChevronRight} className="mr-2" />
            <Link href={getLinkUrl(node.path, config)}>
              <span className="mr-2"> {node.title} </span>
            </Link>
          </Fragment>
        );
      })}
    </div>
  );
};

export default BreadCrumb;
